export const USER_GROUPS_LIST_URL: string = 'account/{accountId}/user-group/list';

export const CREATE_USER_GROUP_URL: string = 'account/{accountId}/user-group/';
export const GET_USER_GROUP_URL: string = 'account/{accountId}/user-group/{userGroupId}';
export const EDIT_USER_GROUP_URL: string = 'account/{accountId}/user-group/{userGroupId}';
export const DELETE_USER_GROUP_URL: string = 'account/{accountId}/user-group/{userGroupId}';


